define('modules/modal/modal_view',[
  'backbone',
  'jquery',
  '_',
  'modules/animation/transition-end',

  'text!./modal_template.html'
], function (Backbone, $, _,
             transitionEnd,
             modal_template) {
  'use strict';
  var Modal = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);




      this.model = new Backbone.Model({
        title: opts.title || '',
        css_class: opts.css_class || '',
        close: opts.close || _.t('modal.button.close'),
        bottom_toolbar: opts.bottom_toolbar || false
      });

      $(document).on('keyup.modal', this.escape.bind(this));
      $(document).on('focusin', this.trapFocus.bind(this));

      this.on('close', this.close.bind(this));
      this.listenTo(this.modalContent, 'close', this.close.bind(this));
      this.on('remove', this.remove.bind(this));
      this.listenTo(this.modalContent, 'remove', this.remove.bind(this));

      if(this.hide_background) {
        this.el.classList.add('opaque');
      }

      // this.render();
    },

    hasSidebar: false,
    transitionEvent: transitionEnd,
    subViews: [],
    tagName: 'div',
    className: 'modal-overlay',
    container: $('body'),

    template: _.template(modal_template),

    events: {
      'click .close-button': 'close',
      'click .js-cancel-button': 'close',
      'click': 'overlayClickHandler'
    },

    escape: function (e) {
      if (!this.prevent_cancel && e.keyCode === 27) {
        this.close();
        this.trigger('escaped');
      }
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },

    open: function (opts) {
      this.container = opts && opts.container || this.container;
      if (typeof this.container === 'string') {
        this.container = $(this.container);
      }

      this.lastFocus = document.activeElement;

      this.container.append(this.render().$el);
      this.$('.js-modal-content').html(this.modalContent.render().$el);
      this.subViews.push(this.modalContent);
      $('html').addClass('has-modal');
      this.trigger('open');

      if (this.auto_focus) {
        this.$(this.auto_focus).attr('autofocus', true);
      }

    },

    overlayClickHandler: function (e) {
      if (!this.prevent_cancel && e.target === this.el) {
        this.close();
      }
    },

    close: function () {
      var self = this;
      this.$('.modal-body')[0].addEventListener(this.transitionEvent, function () {
        setTimeout(function() {
          self.remove();
          self.trigger('closed');
        }, 0);


      });
      this.$('.modal-body').addClass('is-closed');
      this.$el.addClass('is-closed');

      $('html').removeClass('has-modal');
      if (this.lastFocus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }

    },

    trapFocus: function (e) {
      var focusInModal = this.el.contains(e.target);
      if (!focusInModal) {
        e.stopPropagation();
        var bd = this.$('.modal-body');
        if (!this.auto_focus) {
          bd.focus();
        }
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      $(document).off('keyup.modal');
      this.stopListening();
      return this;
    }
  });

  return Modal;

});

